import colors from '../globals/colors';
const sort = {
    colors: {
        white: colors.grey0,
        black84: colors.grey84,
    },
    active: {
        background: colors.secondary.normal,
        color: colors.grey0,
        hover: {
            background: colors.secondary.normal,
            color: colors.grey0,
        },
    },
    inactive: {
        background: colors.grey0,
        color: colors.grey48,
        hover: {
            background: colors.grey0,
            color: colors.grey48,
        },
    },
};
export default sort;
